import {apolloClient} from '@/graphql/apolloWrapper'
import {GET_LIST_VODGUIDE} from "../../graphql/queries/vodguide/list";

const state = {
  vodguidePage: [],
};

const getters = {
  vodguidePage: state => state.vodguidePage
};

const mutations = {
  UPDATE_VODGUIDE_LIST (state, payload) {
    state.vodguidePage = payload.vodguide;
  },
};

const actions = {
  async vodguideFetchList ({commit}, payload) {
    const {data} = await apolloClient.query({
      query: GET_LIST_VODGUIDE,
      variables: {perPage: payload.perPage, page: payload.page, search: payload.search}
    });

    if (data && data.vodguideList) {
      commit('UPDATE_VODGUIDE_LIST', {vodguide: data.vodguideList});
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vodguide.js